import React from 'react'
import Sheet from '@mui/joy/Sheet';
import CssBaseline from '@mui/joy/CssBaseline';
import useScreenWidth from '../../../store/useScreenWidth';
import DarkModeBtn from '../../../common/TopBar/Buttons/DarkModeBtn';
import TranslateBtn from '../../../common/TopBar/Buttons/TranslateBtn';
import { EndPoints } from '../../../utils/apiEndpoints';
import { darkModeBackgroud } from '../../../utils/constants';
import { useNavigate } from 'react-router-dom';
import { useDarkModeStore } from '../../../store/useDarkModeStore';
import { ReactComponent as Logo } from '../../../images/Logo_svg.svg'
import { ReactComponent as LogoText } from '../../../images/Logo_text.svg'

export const HeaderMainPage = () => {
    const navigate = useNavigate();

    const isSmallScreen = useScreenWidth();
    const { darkMode } = useDarkModeStore();

    const sheetCss = {
        py: 3,
        px: 2,
        gap: 0,
        top: 0,
        mx: 'auto',
        zIndex: 100,
        height: '8vh',
        width: '100%',
        display: 'flex',
        position: 'sticky',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0px 8px 15px 0 rgba(0, 0, 0, .1)',
        background: darkMode ? darkModeBackgroud : '#F3F3F7',
    };

    return <>
        <CssBaseline />
        <Sheet
            sx={sheetCss}
        >
            <div className={`w-100 d-flex flex-row align-items-center position-relative ${isSmallScreen ? 'gap-3' : 'gap-5'}`}>
                <div
                    className='d-flex flex-row gap-2 align-items-center justify-content-center main-header-color'
                    role='button'
                    onClick={() => navigate(EndPoints.LOGIN)}
                >
                    <Logo width="30" height="30" />
                    <LogoText width="130" height="105" />
                </div>
                <span
                    className='main-header-item ms-auto'
                >
                    <TranslateBtn />
                    <DarkModeBtn styleClass="main-header-color" />
                </span>

            </div>
        </Sheet>
    </>
}
export default HeaderMainPage